export const TOTAL_AMOUNT = 'TOTAL_AMOUNT';
export const WEIGHTED_AMOUNT = 'WEIGHTED_AMOUNT';
export const FORECAST_AMOUNT = 'FORECAST_AMOUNT';